import * as angular from 'angular';

import { DirectiveDefinition } from './directiveDefinition';

class WidgetBodyController {
    static $inject = [
        '$scope',
        '$compile',
        '$element'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$compile: angular.ICompileService,
        private _$element: angular.IAugmentedJQuery
    ) {
    }

    $onInit() {
        const template = this._$scope['item'].template;
        const newElement = angular.element(template);
        this._$element.append(newElement);
        this._$compile(newElement)(this._$scope);
    }
}

export const wtWidgetBodyDirective: DirectiveDefinition = {
    directiveId: 'wtWidgetBody',
    restrict: 'E',
    controller: WidgetBodyController,
    scope: {
        applicationGuid: '<?',
        dashboards: '<?',
        digitalSetDictionary: '<?',
        editedItem: '=',
        formController: '<?',
        groups: '<?',
        isBindable: '=',
        item: '=',
        referenceGroupGuid: '<?',
        stringValues: '<',
        tagsDictionary: '<?',
        viewModels: '<?'
    },
};